if (window.matchMedia && window.matchMedia('(min-width: 64rem)').matches) {

(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function initDragScroll(container) {
    if (!container) return;

    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let moved = false;
    let lastX = 0;
    let lastTime = 0;
    let velocityX = 0;
    let momentumId = null;
    const moveThreshold = 5;
    const friction = 0.95;
    const minVelocity = 0.5;

    container.classList.add('is-draggable');

    function onMouseDown(event) {
      if (event.button !== 0) return;
      const target = event.target;
      
      const isImageInLink = target.tagName === 'IMG' && target.closest('a');
      if (!isImageInLink && target.closest('button, input, textarea, select')) return;
      
      if (momentumId) {
        cancelAnimationFrame(momentumId);
        momentumId = null;
      }
      
      isDragging = true;
      moved = false;
      startX = event.pageX;
      lastX = event.pageX;
      lastTime = Date.now();
      startScrollLeft = container.scrollLeft;
      velocityX = 0;
      container.classList.add('is-dragging');
      
      event.preventDefault();
      
      const originalScrollBehavior = container.style.scrollBehavior;
      const originalScrollSnap = container.style.scrollSnapType;
      container.style.scrollBehavior = 'auto';
      container.style.scrollSnapType = 'none';
      container.dataset.originalScrollBehavior = originalScrollBehavior;
      container.dataset.originalScrollSnap = originalScrollSnap;

      document.addEventListener('mousemove', onMouseMove, { passive: false });
      document.addEventListener('mouseup', endDrag, { passive: true });
    }

    function onMouseMove(event) {
      if (!isDragging) return;
      event.preventDefault();
      
      const currentTime = Date.now();
      const currentX = event.pageX;
      const deltaX = currentX - startX;
      const timeDelta = currentTime - lastTime;
      
      if (Math.abs(deltaX) > moveThreshold) moved = true;
      
      if (timeDelta > 0) {
        velocityX = (currentX - lastX) / timeDelta * 16;
      }
      
      container.scrollLeft = startScrollLeft - deltaX;
      
      lastX = currentX;
      lastTime = currentTime;
    }

    function applyMomentum() {
      if (Math.abs(velocityX) < minVelocity) {
        restoreScrollBehavior();
        momentumId = null;
        return;
      }
      
      container.scrollLeft -= velocityX;
      velocityX *= friction;
      
      momentumId = requestAnimationFrame(applyMomentum);
    }

    function restoreScrollBehavior() {
      const originalScrollBehavior = container.dataset.originalScrollBehavior || '';
      const originalScrollSnap = container.dataset.originalScrollSnap || '';
      
      if (originalScrollBehavior === '') {
        container.style.removeProperty('scroll-behavior');
      } else {
        container.style.scrollBehavior = originalScrollBehavior;
      }
      
      if (originalScrollSnap === '') {
        container.style.removeProperty('scroll-snap-type');
      } else {
        container.style.scrollSnapType = originalScrollSnap;
      }
      
      delete container.dataset.originalScrollBehavior;
      delete container.dataset.originalScrollSnap;
    }

    function endDrag(event) {
      if (!isDragging) return;
      isDragging = false;
      container.classList.remove('is-dragging');

      document.removeEventListener('mousemove', onMouseMove, { passive: false });
      document.removeEventListener('mouseup', endDrag, { passive: true });
      
      if (Math.abs(velocityX) > minVelocity) {
        applyMomentum();
      } else {
        restoreScrollBehavior();
      }
      
      if (moved) {
        setTimeout(() => {
          moved = false;
        }, 100);
      }
    }

    function onClick(event) {
      if (moved) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    }

    container.addEventListener('mousedown', onMouseDown, { passive: false });
    container.addEventListener('click', onClick, { capture: true });
  }

  function initAll() {
    document
      .querySelectorAll('[data-drag-scroll="true"]')
      .forEach(initDragScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();

}


